export const strings = {
  brand_slogan: { en: "Handmade Fresh-Baked Burgers", ms: "Burger Bakar Segar Buatan Tangan" },
  nav_home: { en: "Home", ms: "Utama" },
  nav_story: { en: "Brand Story", ms: "Kisah Jenama" },
  nav_products: { en: "Products", ms: "Produk" },
  nav_franchise: { en: "Franchise", ms: "Francais" },
  nav_news: { en: "News", ms: "Berita" },
  nav_contact: { en: "Contact", ms: "Hubungi" },
  nav_login: { en: "Login", ms: "Log Masuk" },
  nav_join: { en: "Join Now", ms: "Sertai" },
  nav_member: { en: "My Rewards", ms: "Ganjaran" },
  nav_admin: { en: "Admin", ms: "Admin" },
  nav_logout: { en: "Logout", ms: "Log Keluar" },

  hero_eyebrow: { en: "Fresh from Malaysia", ms: "Segar dari Malaysia" },
  hero_title: { en: "Freshly Baked Daily", ms: "Dibakar Segar Setiap Hari" },
  hero_sub: { en: "Handmade patties, fresh-baked buns, stacked the Panda Tata way. Made for the young & hungry.", ms: "Patti buatan tangan, buns bakar segar, disusun ala Panda Tata. Untuk yang muda & lapar." },
  hero_cta_menu: { en: "See the Menu", ms: "Lihat Menu" },
  hero_cta_join: { en: "Join Rewards", ms: "Sertai Ganjaran" },

  home_products_title: { en: "The Line-Up", ms: "Barisan Menu" },
  home_products_sub: { en: "Our signature stacks", ms: "Susunan istimewa kami" },
  home_view_all: { en: "View all", ms: "Lihat semua" },
  home_story_title: { en: "Born to be fresh", ms: "Lahir untuk segar" },
  home_franchise_title: { en: "Own a Panda Tata", ms: "Miliki Panda Tata" },
  home_franchise_sub: { en: "Bring handmade burgers to your city.", ms: "Bawa burger buatan tangan ke bandar anda." },
  home_franchise_cta: { en: "Become a Partner", ms: "Jadi Rakan Niaga" },
  follow_us: { en: "Follow the pack", ms: "Ikuti kami" },

  story_title: { en: "Our Story", ms: "Kisah Kami" },
  products_title: { en: "Products", ms: "Produk" },
  products_sub: { en: "Every burger, handmade & fresh-baked daily.", ms: "Setiap burger, buatan tangan & dibakar segar setiap hari." },
  all_categories: { en: "All", ms: "Semua" },
  share: { en: "Share", ms: "Kongsi" },
  order_whatsapp: { en: "Order on WhatsApp", ms: "Pesan di WhatsApp" },

  franchise_title: { en: "Franchise With Us", ms: "Francais Bersama Kami" },
  franchise_sub: { en: "Join a fast-growing burger movement in Malaysia.", ms: "Sertai gerakan burger yang pesat membangun di Malaysia." },
  download_brandbook: { en: "Download Brand Book", ms: "Muat Turun Buku Jenama" },
  form_name: { en: "Full Name", ms: "Nama Penuh" },
  form_phone: { en: "Phone Number", ms: "Nombor Telefon" },
  form_email: { en: "Email", ms: "E-mel" },
  form_message: { en: "Message", ms: "Mesej" },
  submit: { en: "Submit", ms: "Hantar" },
  chat_whatsapp: { en: "Chat on WhatsApp", ms: "Sembang di WhatsApp" },
  franchise_thanks: { en: "Thanks! Our team will contact you soon.", ms: "Terima kasih! Pasukan kami akan menghubungi anda." },

  news_title: { en: "Latest News", ms: "Berita Terkini" },
  news_sub: { en: "What's fresh at Panda Tata.", ms: "Yang terbaru di Panda Tata." },
  read_more: { en: "Read more", ms: "Baca lagi" },
  back: { en: "Back", ms: "Kembali" },

  contact_title: { en: "Find Us", ms: "Cari Kami" },
  contact_sub: { en: "Visit an outlet or reach our team.", ms: "Kunjungi cawangan atau hubungi pasukan kami." },
  navigate: { en: "Navigate", ms: "Navigasi" },
  contacts: { en: "Contacts", ms: "Hubungan" },
  open_now: { en: "Open now", ms: "Sedang Buka" },
  closed_now: { en: "Closed", ms: "Tutup" },

  login_title: { en: "Welcome Back", ms: "Selamat Kembali" },
  register_title: { en: "Join Panda Tata", ms: "Sertai Panda Tata" },
  password: { en: "Password", ms: "Kata Laluan" },
  no_account: { en: "No account? Register", ms: "Tiada akaun? Daftar" },
  have_account: { en: "Have an account? Login", ms: "Ada akaun? Log masuk" },

  points: { en: "Points", ms: "Mata" },
  my_points: { en: "Burger Points", ms: "Mata Burger" },
  upload_receipt: { en: "Upload Receipt", ms: "Muat Naik Resit" },
  amount_rm: { en: "Amount (RM)", ms: "Jumlah (RM)" },
  receipt_hint: { en: "RM1 = 1 point. Points awarded after admin approval.", ms: "RM1 = 1 mata. Mata diberi selepas kelulusan admin." },
  my_receipts: { en: "My Receipts", ms: "Resit Saya" },
  rewards_store: { en: "Rewards Store", ms: "Kedai Ganjaran" },
  redeem: { en: "Redeem", ms: "Tebus" },
  my_vouchers: { en: "My Vouchers", ms: "Baucar Saya" },
  use_now: { en: "Use Now", ms: "Guna Sekarang" },
  used: { en: "Used", ms: "Telah Guna" },
  pending: { en: "Pending", ms: "Menunggu" },
  approved: { en: "Approved", ms: "Diluluskan" },
  rejected: { en: "Rejected", ms: "Ditolak" },

  tier_bonus: { en: "bonus", ms: "bonus" },
  lifetime: { en: "Lifetime", ms: "Sepanjang Hayat" },
  pts_to: { en: "pts to", ms: "mata ke" },
  max_tier: { en: "Max tier", ms: "Tahap Tertinggi" },
  only: { en: "only", ms: "sahaja" },
  active_v: { en: "Active", ms: "Aktif" },
  redeemed_on: { en: "Redeemed", ms: "Ditebus" },
  used_on: { en: "Used", ms: "Digunakan" },
  profile: { en: "Profile", ms: "Profil" },
  birthday_reward: { en: "Birthday Reward", ms: "Ganjaran Hari Jadi" },
  birthday_hint: { en: "Set your birthday and get 200 bonus burger points on your special day, every year!", ms: "Tetapkan hari jadi anda dan dapatkan 200 mata burger bonus pada hari istimewa anda, setiap tahun!" },
  birthday: { en: "Birthday", ms: "Hari Jadi" },
  your_birthday: { en: "Your birthday", ms: "Hari jadi anda" },
  save: { en: "Save", ms: "Simpan" },
  coming_soon: { en: "coming soon", ms: "akan datang" },
  optional: { en: "optional", ms: "pilihan" },
  referral_code: { en: "Referral Code", ms: "Kod Rujukan" },
  refer_friends: { en: "Refer Friends", ms: "Rujuk Rakan" },
  refer_hint: { en: "Share your code. When a friend signs up and gets their first receipt approved, you earn 150 points and they get 50!", ms: "Kongsi kod anda. Apabila rakan mendaftar dan resit pertama mereka diluluskan, anda dapat 150 mata dan mereka dapat 50!" },
  your_code: { en: "Your code", ms: "Kod anda" },
  copy_link: { en: "Copy link", ms: "Salin pautan" },
  friends_joined: { en: "Friends joined", ms: "Rakan menyertai" },
  sold_out: { en: "Sold out", ms: "Habis" },
  left: { en: "left", ms: "lagi" },
  show_qr: { en: "Show QR", ms: "Tunjuk QR" },
  qr_hint: { en: "Show this to outlet staff to redeem", ms: "Tunjukkan kepada staf cawangan untuk tebus" },
  close: { en: "Close", ms: "Tutup" },
};
